<template>
  <section class="section-container" v-if="!is_supplier">
    <div class="content-wrapper">
      <div class="content-heading">
        {{ module.name }} {{ $t('module.config') }}
      </div>
      <div class="row">
        <div class="col-xl-4">
          <div class="card card-default">
            <div class="card-body">
              <form @submit.prevent="save" class="form-modal form-module">
                <div class="form-group">
                  <label for="name">{{ $t('module.name') }} *</label>
                  <input
                    :class="{'parsley-error': errors.name}"
                    autocomplete="off"
                    class="form-control"
                    id="name"
                    :placeholder="$t('module.insert-name')"
                    type="text"
                    v-model="module.name">
                  <ul class="parsley-errors-list filled" v-if="errors.name">
                    <li class="parsley-required">{{ errors.name[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="name">{{ $t('module.url') }} *</label>
                  <input
                    :class="{'parsley-error': errors.url}"
                    autocomplete="off"
                    class="form-control"
                    id="url"
                    :placeholder="$t('module.insert-url')"
                    type="text"
                    v-model="module.url">
                  <ul class="parsley-errors-list filled" v-if="errors.url">
                    <li class="parsley-required">{{ errors.url[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="name">{{ $t('module.key') }} *</label>
                  <input
                    :class="{'parsley-error': errors.key}"
                    autocomplete="off"
                    class="form-control"
                    id="key"
                    :placeholder="$t('module.insert-key')"
                    type="text"
                    v-model="module.key">
                  <ul class="parsley-errors-list filled" v-if="errors.key">
                    <li class="parsley-required">{{ errors.key[0] }}</li>
                  </ul>
                </div>

                <div class="row pb-3">
                  <div class="col-md-6">
                    <div class="checkbox c-checkbox">
                      <label for="is_active">
                        <input
                          v-model="module.is_active"
                          :class="{'parsley-error': module.is_active}"
                          class="form-control"
                          type="checkbox"
                          id="is_active">
                        <span class="fa fa-check"></span>{{ $t('module.status') }}
                      </label>
                    </div>
                  </div>
                </div>
                <buttons url="modules"/>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import Buttons from '@/components/Buttons.vue'
import message from '@/message'
import {parseApiError} from '@/utils'

const getData = (id, next) => {
  if (id) {
    Promise.all([api.get(`/modules/${id}/`)])
      .then(([module]) => {
        next({
          module: module.data
        })
      })
  } else {
    next({
      module: {
        name: '',
        url: '',
        key: '',
        is_active: true
      }
    })
  }
}

export default {
  components: {
    buttons: Buttons
  },
  data () {
    return {
      module: {},
      errors: {}
    }
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    }
  },
  mounted () {
    this.$parent.menu = 'modules'
    this.$parent.submenu = ''
    this.$i18n.locale = this.$store.getters.language
  },
  methods: {
    save () {
      this.errors = {}

      if (this.module.id) {
        api.patch(`/modules/${this.module.id}/`, this.module)
          .then(() => {
            message.success('Module changed')
            this.$router.push({name: 'modules'})
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
            } else {
              message.error(errors)
            }
          })
      } else {
        api.post('/modules/', this.module)
          .then(() => {
            message.success('Module added')
            this.$router.push({name: 'modules'})
          })
          .catch(error => {
            let errors = parseApiError(error, this.$i18n)
            if (error.response && error.response.status === 400) {
              this.errors = errors
            } else {
              message.error(errors)
            }
          })
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    getData(to.params.id, data => {
      next(vm => {
        Object.assign(vm.$data, data)
      })
    })
  },
  beforeRouteUpdate (to, from, next) {
    getData(to.params.id, data => {
      Object.assign(this.$data, data)
      next()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Module.vue